"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withCommonDiaryOptions = void 0;
const withCommonDiaryOptions = (options) => {
    const optionsWithAuthor = {
        "AUTHOR": {
            option: "Autor hlášení",
            placeholder: "Hledat dle autora hlášení ...",
            getSearchStrings: (diary) => {
                return [diary.value.provedl, diary.value.email, diary.value.uzivatel, diary.value.telefon];
            }
        },
        ...options,
    };
    return {
        'SMART': {
            option: "Chytré hledání",
            placeholder: "Hledat dle autora, označení objektu ...",
            getSearchStrings: (diary) => {
                return Object.values(optionsWithAuthor).flatMap(option => option.getSearchStrings(diary));
            }
        },
        ...optionsWithAuthor,
    };
};
exports.withCommonDiaryOptions = withCommonDiaryOptions;
